import { defineComponent as _defineComponent } from 'vue'
import {onMounted, ref} from 'vue';
import moment from 'moment';
import {getTodayWantToBuyOfPush, getTodayProcessingOfPush} from '@/api/push';
import {getProcessingContact} from '@/api/miscellaneous';
import RestrictDialog from '@/components/RestrictDialog.vue';
import {useRouter} from 'vue-router';
import userStoreModule from '@/store/modules/user';
import {calcDistance} from '@/libs/utils';
import BindingPhone from '@/components/bindingPhone';
import {listSubscribe, turnPages} from '@/hooks';
import Cookies from 'js-cookie';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendedToday',
  setup(__props, { expose }) {
  expose();

const router = useRouter();

const {subscribe, isSubscribe} = listSubscribe();
const active = ref(0);
const showCheckIn = ref(false);

// const wantToBuyList = ref<any[]>([]);
// const processingList = ref<any[]>([]);
onMounted(() => {
    showCheckIn.value = !Cookies.get('isSignIn');
});

const getWantToBuyData = ref({
    // page: 1,
    // size: 20,
    lat: 0,
    lon: 0,
    sort: '',
});
const {
    list: wantToBuyList,
    loading: wLoading,
    loadMore: getWantToBuyList,
    finished: wFinished,
} = turnPages({
    api: getTodayWantToBuyOfPush,
    params: getWantToBuyData,
    loadingReturn: true,
});

const {
    list: processingList,
    loading: pLoading,
    loadMore: geProcessingList,
    finished: pFinished,
} = turnPages({
    api: getTodayProcessingOfPush,
    loadingReturn: true,
});

const restrictShow = ref(false);
const isShowTel = ref(false);
const restrictCode = ref('');
const tel = ref('');

getWantToBuyList();
// geProcessingList();

const tabChange = (tab: any) => {
    if (tab === 1 && processingList.value.length === 0) {
        geProcessingList();
    }
};

const timeToNow = (time: number) => {
    let cycle = 60 * 1000 * 60 * 24 * 7;
    let ttt = (new Date().getTime() - time) % cycle;
    return moment(new Date().getTime() - ttt).fromNow();
};

const getTell = (id: string): void => {
    getProcessingContact({id})
        .then(res => {
            tel.value = res;
            isShowTel.value = true;
        })
        .catch(e => {
            let {code} = e;
            if ([120].includes(code)) {
                restrictCode.value = code;
                restrictShow.value = true;
            }
        });
};

const distance = (point: {lat: number; lon: number}) => {
    if (userStoreModule.userDetail.location) {
        let {lat, lon} = userStoreModule.userDetail.location;
        const dis = calcDistance({lat: point.lat, lng: point.lon}, {lat, lng: lon});
        return dis > 1000 ? (dis / 1000).toFixed(2) + 'km' : dis.toFixed(2) + 'm';
    } else {
        return '';
    }
};

const __returned__ = { router, subscribe, isSubscribe, active, showCheckIn, getWantToBuyData, wantToBuyList, wLoading, getWantToBuyList, wFinished, processingList, pLoading, geProcessingList, pFinished, restrictShow, isShowTel, restrictCode, tel, tabChange, timeToNow, getTell, distance, onMounted, ref, moment, getTodayWantToBuyOfPush, getTodayProcessingOfPush, getProcessingContact, RestrictDialog, useRouter, userStoreModule, calcDistance, BindingPhone, listSubscribe, turnPages, Cookies }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})